import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es difícil de armar?',
  a: 'No, usamos lo que ya tienes y opciones económicas de supermercado.'
}, {
  q: '¿Tengo que comprar equipo militar?',
  a: 'Absolutamente no. El método se enfoca en la inteligencia, no en el camuflaje.'
}, {
  q: '¿Sirve para cualquier estado de EE.UU.?',
  a: 'Sí, está adaptado a las normativas y realidades del sistema estadounidense.'
}, {
  q: '¿En qué formato viene?',
  a: 'Es un PDF digital de alta resolución, listo para leer en tu móvil o imprimir.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-brand-gray border-t border-brand-border" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <FadeIn data-id="element-27">
          <div className="text-center mb-16" data-id="element-28">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-white uppercase" data-id="element-29">
              Preguntas <span className="text-brand-orange" data-id="element-30">Frecuentes</span>
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-31">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-32">
              <div className={`border rounded-lg overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-brand-orange bg-brand-dark' : 'border-brand-border bg-brand-dark/50 hover:border-gray-500'}`} data-id="element-33">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-34">
                  <span className="text-lg font-bold text-white" data-id="element-35">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-brand-orange transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-36" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-37">
                  <p className="text-gray-400 text-lg leading-relaxed" data-id="element-38">
                    {faq.a}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}